<template>
  <v-row>
    <v-col
      cols="12"
    >
      <material-card
        color="primary"
        full-header
      >
        <template #heading>
          <v-tabs
            v-model="tabs"
            background-color="transparent"
            slider-color="white"
            :class="$vuetify.breakpoint.smAndUp ? 'pa-4' : ''"
            @change="tabChanged"
          >
            <span
              v-if="$vuetify.breakpoint.smAndUp"
              class="mx-3"
              style="align-self: center; font-size: 20px !important;"
            >통계 : </span>
            <v-tab class="mr-3">
              <v-icon class="mr-2">
                mdi-table-search
              </v-icon>
              종료된 모든 회의
            </v-tab>
            <v-tab class="mr-3">
              <v-icon class="mr-2">
                mdi-door-open
              </v-icon>
              회의실별 회의 현황
            </v-tab>
            <v-tab>
              <v-icon class="mr-2">
                mdi-account
              </v-icon>
              사용자별 회의 현황
            </v-tab>
          </v-tabs>
        </template>
        <v-row>
          <v-col>
            <!-- filter zone -->
          </v-col>
        </v-row>
        <v-tabs-items
          v-model="tabs"
          background-color="transparent"
        >
          <v-tab-item
            v-for="n in 3"
            :key="n"
          >
            <v-card-text>
              <!-- pc view -->
              <v-data-table
                :headers="getHeaders(tabs)"
                :items="meetings"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalMeetings"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.startDtime="{ item }">
                  {{ item.startDtime | formatDate }}
                </template>
                <template v-slot:item.endDtime="{ item }">
                  {{ item.endDtime | formatDate }}
                </template>
                <template v-slot:item.detail="{ item }">
                  <v-btn
                    icon
                    @click="detailMeeting(item)"
                  >
                    <v-icon
                      color="info"
                    >
                      mdi-information
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </material-card>
      <custom-dialog
        :title="infoDialog.title"
        :dialog="infoDialog.dialog"
        :to-parent="infoDialogClose"
        :is-confirm="true"
      >
        <div slot="content">
          <v-row
            v-if="selectedMeeting !== null"
            justify="center"
            align="center"
          >
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.title"
                readonly
                dense
                hide-details
                label="회의제목"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.startDtime | formatDate"
                readonly
                dense
                hide-details
                label="시작시간"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.endDtime | formatDate"
                readonly
                dense
                hide-details
                label="종료시간"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.roomIds[0].buildingName"
                readonly
                dense
                hide-details
                label="건물"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.roomIds[0].typeName"
                readonly
                dense
                hide-details
                label="유형"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.roomIds[0].name"
                readonly
                dense
                hide-details
                label="회의실"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="selectedMeeting.creator.username ||
                  selectedMeeting.creator.displayName"
                readonly
                dense
                hide-details
                label="예약자"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                :value="selectedMeeting.attendees
                  .map(m => m.displayName ? m.displayName : m.displayFullName).join('\n')"
                readonly
                :auto-grow="selectedMeeting.attendees.length <= 5"
                :rows="selectedMeeting.attendees.length"
                :no-resize="selectedMeeting.attendees.length > 5"
                row-height="20"
                dense
                hide-details
                label="참여자"
              />
              <!-- <div
                :style="selectedMeeting.attendees.length < 10 ? style.general : style.overflow"
                v-html="selectedMeeting.attendees
                  .filter(attendee => attendee.email !== selectedMeeting.creator.email)
                  .map(m => m.displayName ? m.displayName : m.username).join('<br/>')"
              /> -->
            </v-col>
          </v-row>
        </div>
      </custom-dialog>
    </v-col>
  </v-row>
</template>

<script>
  // Utilities
  import moment from 'moment'

  export default {
    name: 'Analytics',

    data: () => ({
      loading: false,
      tabs: 0,
      meetings: [],
      filter: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      options: {
        sortDesc: true,
        page: 1,
        itemsPerPage: 10,
      },
      totalMeetings: 0,
      infoDialog: {
        title: '',
        content: '',
        dialog: false,
      },
      selectedMeeting: null,
      style: {
        overflow: {
          marginTop: '5px',
          marginBottom: '5px',
          height: '200px',
          overflow: 'auto',
        },
        general: {
          marginTop: '5px',
          marginBottom: '5px',
        },
      },
    }),

    watch: {
      options: {
        async handler (val) {
          await this.getMeetings(this.tabs)
        },
        deep: true,
      },
    },

    mounted () {
      // this.getMeetings(this.tabs, true)
    },

    methods: {
      async getMeetings (tabs) {
        this.loading = true

        const { page, itemsPerPage } = this.options
        this.filter.skip = (page - 1) * itemsPerPage
        this.filter.limit = itemsPerPage

        let url = '/api/v1/analytics'
        switch (tabs) {
          case 0:
            break
          case 1:
            url += '/group/room'
            break
          case 2:
            url += '/group/user'
            break
          default:
            break
        }

        await this.$http.get(url + '/counts', { params: this.filter }).then(response => {
          this.totalMeetings = response.data
        }).catch(error => {
          console.log(error)
          this.loading = false
        })

        await this.$http.get(url, { params: this.filter }).then(response => {
          this.meetings = response.data
        }).catch(error => {
          console.log(error)
        })
        this.loading = false
      },
      getHeaders (tabs) {
        const headers = {
          0: [
            { text: this.$t('meeting.sta-time'), value: 'startDtime', width: '150px !important', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.end-time'), value: 'endDtime', width: '150px !important', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.type'), value: 'roomIds[0].typeName', width: '200px !important', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.meeting-room'), value: 'roomIds[0].name', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.creator'), value: 'creator.username', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.title'), value: 'title', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.detail'), value: 'detail', align: 'center', width: '100px', sortable: false, class: 'primary--text' },
          ],
          1: [
            { text: this.$t('meeting.building'), value: 'roomIds[0].buildingName', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.type'), value: 'roomIds[0].typeName', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.meeting-room'), value: 'roomIds[0].name', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.count'), value: 'count', width: '200px !important', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('meeting.total-time'), value: 'totalTime', width: '200px !important', align: 'center', sortable: false, class: 'primary--text' },
          ],
          2: [
            { text: this.$t('analytics.user-name'), value: 'displayName', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('analytics.email'), value: 'email', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('analytics.department'), value: 'department', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('analytics.create-meeting-count'), value: 'createCount', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('analytics.meeting-participant-count'), value: 'participantCount', align: 'center', sortable: false, class: 'primary--text' },
            { text: this.$t('analytics.meeting-participant-time'), value: 'totalDuration', align: 'center', sortable: false, class: 'primary--text' },
          ],
        }
        return headers[tabs]
      },
      detailMeeting (item) {
        this.selectedMeeting = item
        this.infoDialog.title = '회의정보'
        this.infoDialog.dialog = true
      },
      tabChanged (item) {
        this.meetings = []
        this.options.page = 1
        this.getMeetings(item)
      },
      infoDialogClose () {
        this.infoDialog.dialog = false
      },
    },
  }
</script>

<style scoped>

</style>
